import React, { useContext, useState } from "react"
import styled from "styled-components"
import AppNavigationMenu from "navigation-ui/AppNavigationMenu"

import { ScreenContext } from "navigation/screen-context"
import { createStyles, makeStyles } from "@material-ui/core/styles"
import { Theme } from "@material-ui/core/styles"
import clsx from "clsx"
import { MainPlacesMenu } from "./app-bottom-nav"

import { BottomNavigationAdd } from "./CreateBottomNavigationAction"

import { ReactFC } from "types"

import Hidden from "@material-ui/core/Hidden"
import Drawer from "@material-ui/core/Drawer"
import { useIsModal, usePage } from "./profile.selectors"
import { CreatePageMenuItem } from "./navigation-items"
import CreateModal from "Modals/Create/CreateModal"

const PageContainer = styled.div`
  flex: 1;
  width: 100%;
  min-height: 100%;
  display: flex;
  & > *:last-child {
    flex: auto;
  }
`

const PageLeft = styled.div`
  min-height: 100%;
  position: relative;
  & > .MuiBottomNavigation-root {
    height: auto;
  }
  ${({ theme }) => theme.breakpoints.down("xs")} {
    && {
      display: none;
    }
  }

  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  & .MuiBottomNavigation-root {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: theme.appDrawer.width,
      flexShrink: 0,
    },
    drawerOpen: {
      width: theme.appDrawer.width,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: "hidden",
      width: theme.leftNavSize,
    },
    menuOpen: {
      opacity: 1,
      zIndex: 10,
      transition: theme.transitions.create("opacity", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuClose: {
      opacity: 0,
      transition: theme.transitions.create("opacity", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  })
)

const MinimizedMenu = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  top: 20px;
  bottom: 0;

  & .MuiBottomNavigation-root {
    flex-direction: column;
    height: auto;
    width: 100%;
  }
`

const DrawerStyled = styled(Drawer)`
  & .MuiPaper-root {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`

export const PageSectionWithAppMenu: ReactFC<{ create: React.ReactNode }> = ({
  children,
  create,
}) => {
  const classes = useStyles()
  const { minimized, drawerOpen, setDrawerOpen } = useContext(ScreenContext)
  const [openModal, setOpenModal] = useState(false)

  return (
    <>
      <CreateModal handleClose={() => setOpenModal(false)} open={openModal} />
      <PageContainer>
        <PageLeft
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: !minimized,
            [classes.drawerClose]: minimized,
          })}
        >
          <Hidden smUp>
            <DrawerStyled
              variant="temporary"
              anchor="left"
              open={drawerOpen}
              onClose={() => setDrawerOpen((v) => !v)}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              <AppNavigationMenu create={create} />
            </DrawerStyled>
          </Hidden>
          <MinimizedMenu
            className={clsx({
              [classes.menuOpen]: minimized,
              [classes.menuClose]: !minimized,
            })}
          >
            <MainPlacesMenu>
              <BottomNavigationAdd onClick={() => setOpenModal(!openModal)} />
            </MainPlacesMenu>
          </MinimizedMenu>

          <AppNavigationMenu
            className={clsx({
              [classes.menuOpen]: !minimized,
              [classes.menuClose]: minimized,
            })}
            create={create}
          />
        </PageLeft>
        {children}
      </PageContainer>
    </>
  )
}

export const MainPageContainer: ReactFC = ({ children }) => {
  // const modal = useIsModal()
  // const { page } = usePage()
  // if (page.nonav) {
  //   return <PageContainer>{children}</PageContainer>
  // }
  // if (modal) {
  //   return <PageContainer>{children}</PageContainer>
  // }


    return <PageContainer>{children}</PageContainer>
  // return (
  //   <PageSectionWithAppMenu create={<CreatePageMenuItem />}>
  //     {children}
  //   </PageSectionWithAppMenu>
  // )
}
